import {BaseComponentLocator} from './base.component-locator';


export class DisciplineLocatorComponent extends BaseComponentLocator {

  readonly outdoorCode = 1;
  readonly indoorCode = 2;

  protected _id: number = null;


  public toString(): string {
    let label = 'inoutdoor';
    if (this.id === this.outdoorCode) {
      label = 'outdoor';
    }
    else if (this.id === this.indoorCode) {
      label = 'indoor';
    }
    return label;
  }

  /**
   * disciplineId setter/getter.
   */
  public set id(disciplineId: number) {
    this._id = disciplineId;
  }

  public get id(): number {
    return this._id;
  }

  /**
   *
   */
  public setOutdoor() {
    this.id = this.outdoorCode;
  }

  public setIndoor() {
    this.id = this.indoorCode;
  }
}

